
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.714.5H4.286v6.353H0l7.5 7.412L15 6.853h-4.286V.5zM8.571 2.618V8.97h1.254L7.5 11.268 5.175 8.971h1.253V2.618h2.143zM0 18.5v-2.118h15V18.5H0z","fill":"#C4C4C4"}})])
          )
        }
      }
    